import { useMutation, useQuery } from '@apollo/client'
import { updateNotificationPreferences } from 'api/mutations/reader'
import { getNotificationPreferences } from 'api/queries/user'
import type {
  Data,
  MutationData,
  Payload
} from './useNotificationPreferences.types'

const useNotificationPreferences = () => {
  const { data, loading: isFetching } = useQuery<Data>(
    getNotificationPreferences,
    {
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    }
  )
  const [toggleNotification, { loading: isMutating, data: mutationData }] =
    useMutation<MutationData, Payload>(updateNotificationPreferences)

  return {
    weeklyReadingReport:
      mutationData?.toggleNotificationStatus?.weeklyReadingReport ??
      data?.notificationsPreferences?.weeklyReadingReport ??
      false,
    toggleNotification,
    isFetching,
    isMutating
  }
}

export default useNotificationPreferences
